import React from "react";
import PropTypes from "prop-types";
import FacilityGeneralInfoContainer from "./info/FacilityGeneralInfoContainer";
import FacilityWarrantyContainer from "./warranties/FacilityWarrantyContainer"

const FacilityGeneralDataContainer = ({ documentId, siteId, history }) => {
  return (
    <React.Fragment>
      <FacilityGeneralInfoContainer documentId={documentId} siteId={siteId} history={history} />
      <FacilityWarrantyContainer documentId={documentId} siteId={siteId}/>
    </React.Fragment>
  );
};

FacilityGeneralDataContainer.propTypes = {
  history: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number
};

export default FacilityGeneralDataContainer;
